import {BuildTypeEnum} from 'src/constants/BuildTypeEnum';
import {TypeDescriber} from 'src/types/TypeDescriber';

export function createTypeDescriber<T>(
  baseDescriptor: T,
): TypeDescriber<T> {
  const typeDescriber: TypeDescriber<T> = {};
  Object.keys(BuildTypeEnum).forEach((key) => {
    typeDescriber[key] = baseDescriptor;
  });
  return typeDescriber;
}
